import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "payment-reconfirm-container" }
const _hoisted_2 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Retry Payment"),
  /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "Re-enter your payment info for your meeting")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "info-container" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "info-title" }, "Your Info", -1 /* HOISTED */)
const _hoisted_7 = { class: "info-data" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "info-title" }, "Meeting With", -1 /* HOISTED */)
const _hoisted_10 = { class: "info-data" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "info-title" }, "Date & Time", -1 /* HOISTED */)
const _hoisted_13 = { class: "info-data" }
const _hoisted_14 = { class: "info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "info-title" }, "Price", -1 /* HOISTED */)
const _hoisted_16 = { class: "info-data" }
const _hoisted_17 = { class: "payment-container" }
const _hoisted_18 = { class: "checkbox-container" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "description-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "I have confirmed that the payment method selected should have the necessary funds and authorize Opt to retry")
], -1 /* HOISTED */)
const _hoisted_20 = { class: "button-container" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["Loader"], { class: "loading" })
        ]))
      : _createCommentVNode("v-if", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString($setup.userName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString($setup.recipientName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, _toDisplayString($setup.date), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", _hoisted_16, _toDisplayString($setup.props.meeting.price.currency) + _toDisplayString($setup.props.meeting.price.amount) + " for " + _toDisplayString($setup.props.meeting.meetingLength) + " minutes", 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode($setup["PaymentButton"], {
        payment: $setup.selectedPaymentId,
        "onUpdate:payment": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedPaymentId) = $event)),
        price: $setup.props.meeting.price.amount
      }, null, 8 /* PROPS */, ["payment", "price"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode($setup["VCheckbox"], {
        class: "checkbox",
        modelValue: $setup.consentGiven,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.consentGiven) = $event))
      }, null, 8 /* PROPS */, ["modelValue"]),
      _hoisted_19
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        class: "primary confirm-and-pay-btn",
        disabled: !$setup.selectedPaymentId || !$setup.consentGiven,
        onClick: $setup.retryPayment
      }, "Retry Payment", 8 /* PROPS */, _hoisted_21)
    ])
  ]))
}